// extracted by mini-css-extract-plugin
export var title = "get-started-module--title--x-lBv";
export var section = "get-started-module--section--dfbhI";
export var head = "get-started-module--head--3rf0P";
export var head_left = "get-started-module--head_left--_0PR2";
export var head_right = "get-started-module--head_right--2H2V-";
export var head_circle = "get-started-module--head_circle--1xGqJ";
export var subtitle = "get-started-module--subtitle--3iHzo";
export var btnWrap = "get-started-module--btnWrap--TTd3L";